import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import { useAuth } from '../../hooks/useAuth';

export const NotificationBadge = () => {
  const [unreadCount, setUnreadCount] = useState(0);
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    const fetchUnreadCount = async () => {
      const { count, error } = await supabase
        .from('notifications')
        .select('*', { count: 'exact', head: true })
        .eq('user_id', user.id)
        .eq('read', false);

      if (!error && count !== null) {
        console.log('Nombre de notifications non lues:', count);
        setUnreadCount(count);
      }
    };

    const setupRealtimeSubscription = async () => {
      await fetchUnreadCount();

      const channel = supabase.channel(`notifications-${user.id}`, {
        config: {
          broadcast: { self: true }
        }
      });

      channel
        .on(
          'postgres_changes',
          {
            event: 'INSERT',
            schema: 'public',
            table: 'notifications',
            filter: `user_id=eq.${user.id}`
          },
          async (payload) => {
            console.log('Nouvelle notification:', payload);
            await fetchUnreadCount();
          }
        )
        .on(
          'postgres_changes',
          {
            event: 'UPDATE',
            schema: 'public',
            table: 'notifications',
            filter: `user_id=eq.${user.id}`
          },
          async (payload) => {
            console.log('Notification mise à jour:', payload);
            await fetchUnreadCount();
          }
        )
        .on(
          'postgres_changes',
          {
            event: 'DELETE',
            schema: 'public',
            table: 'notifications',
            filter: `user_id=eq.${user.id}`
          },
          async () => {
            console.log('Notification supprimée');
            await fetchUnreadCount();
          }
        );

      const status = await channel.subscribe();
      console.log('Status de l\'abonnement:', status);

      return () => {
        channel.unsubscribe();
      };
    };

    setupRealtimeSubscription();
  }, [user]);

  if (unreadCount === 0) return null;

  return (
    <div className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
      {unreadCount > 99 ? '99+' : unreadCount}
    </div>
  );
}; 